// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2GMf-","title":"InfoRow_title__3Hu6o"};